<template>
  <div class="w-100 pageDpst">
    <div class="col-12 col-xl-6 mx-auto mobpad-0">
      <!-- <alert-notification v-if="notification_msg != ''" /> -->
      <loader v-if="pageLoader" />
      <div class="lightgrayBG selectWallet cap_exhange_cur">
        <div class="walletBlock position-relative">
          <label class="mb-2">Select Wallet to deposit</label>
          <div @click.stop="showCurr = !showCurr">
            <div class="dropdown cap_fund cur_ico">
              <button class="border bg-white cap_btn dropdown-toggle px-3" type="button">
                <img class="cp__ico" :src="'../../../../static/website/images/crypto_logos/' +selected_currency.toLowerCase() +'.png' " alt="" @error="handleImgErr($event)" v-if="   selected_currency != '' && checkImage(selected_currency) "/>
                <span class="firstName" v-else-if="selected_currency != ''">{{selected_currency.charAt(0)}}</span>
                <span>{{ selected_currency || "Select Currency" }}</span>
              </button>
            </div>
          </div>
          <div class="dropdown-menu rounded" :class="showCurr ? 'show' : ''">
            <div class="cur_search showCurr">
              <input type="Search" placeholder="Search here" class="searchcrypto" v-model="searchCurr" id="searchCurr" autocomplete="off"/>
            </div>
            <div class="scrolling_text">
              <table class="table table-striped">
                <tbody v-if="withDepoCurList.length > 0">
                  <tr class="pointer" v-for="value in marginList()" @click.prevent="currencyListNameFunc(value)" :class="currencyListNameClassFunc(value)">
                    <td>
                      <span class="d-flex align-items-center icNmae">
                        <img :src="'../../../../static/website/images/crypto_logos/'+value.symbol.toLowerCase()+'.png' " @error="handleImgErr($event)" v-if="checkImage(value.symbol)" />
                        <span class="firstName currErr" v-else>{{value.symbol.charAt(0)}}</span>
                        <span class="muted semibold" v-if="$env_var.restricted_currencies.hasOwnProperty(value.symbol)">
                          <span>{{ $env_var.restricted_currencies[value.symbol].currency_name}}</span>
                          <span class="fullName">{{value.currency_name}}</span>
                        </span>
                        <span class="muted semibold" v-else>
                          <span>{{ value.symbol}}</span>
                          <span class="fullName">{{value.currency_name}}</span>
                        </span>
                      </span>
                    </td>
                    <td align="right">
                      <span class="f-16 d-block">{{formatfloat(value.amount) || 0 }}</span>
                      <!-- <p class="mb-0 f-12">BTC</p> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="themecolor text-right mt-2">Current Balance: {{ currentBal }} {{ selected_currency }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between my-4">
          <div class="walletBlock position-relative mb-0 calcBarWidth" :class="generateWalletAddress ? 'enabled' : 'disabled'">
            <label class="mb-2">Wallet Address</label>
            <div class="bg-white border position-relative copyCode" v-if="!['EOS', 'XLM'].includes(selected_currency.toUpperCase())">
              <div class="copied" v-if="copy_msg1">
                <span>Copied</span>
              </div>
              <p class="mb-0">
                {{ generateWalletAddress ? generateWalletAddress : "-" }}
              </p>
              <a href="javascript:void(0)" class="copyBtn position-absolute" v-clipboard:copy="generateWalletAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
                <feather type="copy"></feather>
              </a>
            </div>
            <div class="bg-white border position-relative copyCode" v-else>
              <div class="copied" v-if="copy_msg1">
                <span>Copied</span>
              </div>
              <p class="mb-0">{{  generateWalletAddress? generateWalletAddress.split("?")[0] : "-"  }}</p>
              <button class="copyBtn position-absolute" :class="generateWalletAddress ? 'enabled' : 'disabled'" v-clipboard:copy="generateWalletAddress? generateWalletAddress.split('?')[0]: '-'" v-clipboard:success="onCopy" v-clipboard:error="onError">
                <feather type="copy"></feather>
              </button>
            </div>
            <span class="text-right d-block mt-2"
              ><a
                href="javascript:void(0)"
                class="d-inline-flex justify-content-end themecolor medium"
                >Generate New Address</a
              ></span
            >
          </div>
          <!-- disabled -->
          <div class="walletBlock position-relative calcBarWidth" :class="getMemoId(generateWalletAddress) ? 'enabled' : 'disabled'" v-if="['EOS', 'XLM'].includes(selected_currency.toUpperCase())">
            <label class="mb-2">Destination TAG ID</label>
            <div class="bg-white border position-relative copyCode">
              <p class="mb-0">{{ getMemoId(generateWalletAddress) || "-" }}</p>
              <button class="copyBtn position-absolute" @click="copyText = '2'" v-clipboard:copy="getMemoId(generateWalletAddress)" v-clipboard:success="onCopy" v-clipboard:error="onError">
                <feather type="copy"></feather>
              </button>
            </div>
          </div>
          <!-- <label class="medium mb-2">Scan This Barcode:</label> -->
          <div class="scanQrCode" v-if="generateWalletAddress">
            <vue-qrcode :value="generateWalletAddress" />
            <!-- <img src="../../../../static/website/images/bi_qr-code.svg" alt="Bar Code" title="Scan QR Code"> -->
          </div>
        </div>
        <div class="instructions">
          <p class="border-bottom themecolor pb-3 d-flex align-items-center justify-content-between">
            Transaction Fees <span>0 {{ selected_currency }}</span>
          </p>
          <p  class="border-bottom themecolor pb-3 d-flex align-items-center justify-content-between">
            Minimum Deposit <span> 0.0001 {{ selected_currency }}</span>
          </p>
          <!-- <p class="border-bottom themecolor pb-3 d-flex align-items-center justify-content-between">Maximum Deposit<span> No limit</span></p> -->
          <p class="themecolor f-18 uppercase medium mb-1">
            IMPORTANT DEPOSIT INSTRUCTIONS:
          </p>
          <p>
            Incoming transactions show up in your wallet after they have been
            confirmed on the network
          </p>
          <div class="d-flex alertNote align-items-start">
            <feather class="flex-none mr-3" type="alert-triangle"></feather>
            <p>
              Kindly ensure that you deposit to the correct currency type to
              this wallet. Example: Only deposit BTC into a wallet created for
              BTC. If you have mistakenly sent funds to the wrong wallet
              address, you risk losing your funds permanently. And please refer
              to the supported countries list to understand your deposit and
              withdrawal limits.
              <a href="javascript:void(0)" class="link underline">More Details</a>
            </p>
          </div>
        </div>
        <div class="dpositAddress mt-4">
          <a href="javascript:void(0)" class="cap_btn secondaryBG lg min-250" v-clipboard:copy="generateWalletAddress" >Copy Deposit Address</a>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="recentTransactions mt-3 mt-md-5 pt-4">
        <div class="headerElement my-4 d-flex align-items-center justify-content-between">
          <h3 class="mb-0">Deposit History</h3>
          <div class="d-flex align-items-center flex-wrap tpBt">
            <div class="d-flex border align-items-center px-2 py-2 mx-2 border-radius-10">

              <!-- <div class="form-group mb-0">
                
              <select name="Date" class="form-control" v-model="dateType"  @change="changeFilter()">
                <option value="">Select Days</option>
                <option value="7 Days">Last 7 Days</option>
                <option value="15 Days">Last 15 Days</option>
                <option value="30 Days">Last 30 Days</option>
                <option value="3 Months">Last 3 Months</option>
                <option value="6 Months">Last 6 Months</option>
              </select>
            </div> -->
            <a  href="javascript:void(0)"   @click="showDownloadHistoryPopup = true" class="borderBtn ml-2 mb-0" >Download History</a>
            
            </div>


           <!--  <div class="form-group position-relative includeIco searchTable mb-0">
              <input type="text" placeholder="Find Transactions.." name="legal_name" class="form-control small"/>
              <span class="searchIco"><feather type="search"></feather></span>
            </div> -->
          </div>
        </div>
        <div class="border position-relative border-radius-15">
          <div class="table-responsive">
            <table class="table table-striped table-bordered mb-0">
              <thead>
                <tr>
                  <th>Date/ Time</th>
                  <th>Wallet</th>
                  <th>Quantity</th>
                  <th>Destination Address</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody v-if="'totalRecords' in depsitList &&depsitList.totalRecords > 0 &&!pageLoader">
                <tr v-for="(val, index) in depsitList.records">
                  <td>{{ formatDate(val.created) }}</td>
                  <td>
                    <p v-if="$env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</p>
                    <p v-else>{{ val.currency || "-" }}</p>
                  </td>
                  <td>{{ val.amount || "-" }}</td>
                  <td>{{ val.dep_address || "-" }}</td>
                  <td :class="getStatusClass(val.payment_status)">
                    {{ getStatus(val.payment_status) }}
                  </td>
                </tr>
              </tbody>
              <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'8'" :listLength="depsitList.totalRecords" v-else></table-loader>
            </table>
          </div>
          <pagination :totalRecords="depsitList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="'totalRecords' in depsitList && depsitList.totalRecords > 0"></pagination>
        </div>
      </div>
      <p class="mt-3 themecolor">
        Deposit didn’t arrive?
         <router-link class="link underline"  to="/help-centre">Visit help and support page</router-link>
      </p>
    </div>



    <div class="modal fade review show" style="display: block" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" v-if="showDownloadHistoryPopup">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content" >
          <div class="p-4 border-bottom modal-header bg-none">
            <h4 class="mb-0">Deposit History</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showDownloadHistoryPopup = false; dateType = ''">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" >
            <!-- <alert-notification v-if="notification_msg != ''" /> -->
            <!-- <loader v-if="pageLoader" /> -->
            <div class="form-group mb-3">
              <select name="Date" class="form-control" v-model="dateType">
                <option value="">Select Days</option>
                <option value="7 Days">Last 7 Days</option>
                <option value="15 Days">Last 15 Days</option>
                <option value="30 Days">Last 30 Days</option>
                <option value="3 Months">Last 3 Months</option>
                <option value="6 Months">Last 6 Months</option>
              </select>
            </div>
            <div class="form-group mb-0 d-flex align-items-center">
              <a href="javascript:void(0)" class="cap_btn large_btn" @click="changeFilter()">Submit</a>
              <a href="javascript:void(0)" class="cap_btn large_btn border-btn ml-3" @click="showDownloadHistoryPopup = false; dateType = ''">Cancel</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
import moment from "moment";
import tradingMixins from "@/plugins/trading";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import math from "../../../../static/website/js/math.js";
import VueQrcode from "vue-qrcode";
export default {
  name: "deposit-section",
  mixins: [depositWithdrawalMixins, tradingMixins],
  data() {
    return {
      pageLoader: false,

      dateType: "",
      downloadData : {},
      fromDate: "",
      toDate: "",
      showDownloadHistoryPopup : false,


      notification_msg: "",
      notification_type: "",
      errImage: [],

      step: "1",

      margin_list: {},
      showCurr: false,
      selected_currency: "BTC",
      searchCurr: "",
      notCryptoCurrency: ["EURO", "USD", "AUD", "GBP", "JPY"],

      crypto: false,
      copy_msg1: false,
      copy_msg2: false,
      copyText: "1",

      page: "1",
      pageLimit: "10",
    };
  },
  components: {
    VueQrcode,
  },
  computed: {
    currentBal() {
      try {
        let sendCurr = this.selected_currency,  outerCount = 0, returnData = 0  ;
        for(let key in this.margin_list){
          outerCount++
          let  count = 0 ;
          for(let inerkey in this.$env_var.restricted_currencies){
            count++
            if(this.$env_var.restricted_currencies[inerkey].currency_name == this.selected_currency){
              sendCurr = this.$env_var.restricted_currencies[inerkey].orginal_name
            }

            if(count == Object.keys(this.$env_var.restricted_currencies).length){
              if(sendCurr == this.margin_list[key].currency && parseFloat(this.margin_list[key].amount) > 0 ){
                returnData = this.margin_list[key].amount ;
              }
            }
            
          }
          
          if(outerCount == Object.keys(this.margin_list).length){
            console.log('returnData==> ',returnData)
            return returnData;
          }
        }

        // return Object.values(this.margin_list).filter(
        //   (val) =>{
        //     return this.selected_currency == val.currency && parseFloat(val.amount) > 0
        //   }
        // )[0].amount;
      } catch (e) {
        return 0;
      }
    },
  },
  watch: {
    tradingAccount(value) {
      this.getCurrency(value);
      this.listing(value);
    },
  },
  methods: {
    currencyListNameClassFunc(value){
      if(this.$env_var.restricted_currencies.hasOwnProperty(value.symbol) && this.$env_var.restricted_currencies[value.symbol].currency_name == this.selected_currency){
        return 'active' ;
      }else if(value.symbol == this.selected_currency){
        return 'active' ;
      }else{
        return '';
      }
    },
    currencyListNameFunc(value){
      this.selected_currency = value.symbol
      if(this.$env_var.restricted_currencies.hasOwnProperty(value.symbol)){
        this.selected_currency = this.$env_var.restricted_currencies[value.symbol].currency_name
      }
      
      this.searchCurr = ''
      this.transactionLimitCurrency()
    },
    changeFilter() {
      if(this.dateType != ''){
        this.depositListing(this.tradingAccount);
      }else{
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Please select field',
          duration: 1000
        });
      }
    },
    getMemoId(val) {
      try {
        return val.split("?")[1].split("=")[1];
      } catch (e) {
        return null;
      }
    },
    getStatusClass(val) {
      try {
        return this.depositStatus[val].class || "";
      } catch (e) {
        return "";
      }
    },
    getStatus(val) {
      try {
        return this.depositStatus[val].name || "-";
      } catch (e) {
        return "-";
      }
    },
    listing(accounts) {
      if(accounts == undefined || accounts == '' || accounts == null){
        accounts = this.tradingAccount
      }
      
      this.depositListing(accounts);
    },
    depositListing(accounts) {
      if (accounts && accounts.length) {

          let jsonData = {
            globalParams: {
              filter: {
                "deposit.account_id": this.tradingAccount.length
                  ? `${this.tradingAccount[0].account_id}`
                  : "0",
              },
              sort: [],
              search: "",
            },
            localParams: { parameter: this },
          };
          if(this.dateType != ''){
            if (this.dateType == "7 Days") {
              jsonData.globalParams.filter.from = moment().subtract(7, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "15 Days") {
              jsonData.globalParams.filter.from = moment().subtract(15, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "30 Days") {
              jsonData.globalParams.filter.from = moment().subtract(30, "days").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "3 Months") {
              jsonData.globalParams.filter.from = moment().subtract(3, "months").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            } else if (this.dateType == "6 Months") {
              jsonData.globalParams.filter.from = moment().subtract(6, "months").format("YYYY-MM-DD");
              jsonData.globalParams.filter.to = moment().format("YYYY-MM-DD");
            }
            jsonData.localParams.pageFlag = 'download'
          }else{
            jsonData.globalParams.page = this.page;
            jsonData.globalParams.perPage = parseInt(this.pageLimit);
          }
          this._runGetDepsitList(jsonData);
      }
    },
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    checkImage(val) {
      return this.errImage.includes(val.toLowerCase()) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    marginList() {
      let returnData = [],
        notZero = [];
      for (const key1 in this.withDepoCurList) {
        let data = this.withDepoCurList[key1];
        for (const key in this.margin_list) {
          if (
            this.margin_list[key].currency == data.symbol &&
            parseFloat(this.margin_list[key].amount) > 0
          ) {
            data["amount"] = this.margin_list[key].amount;
          }
        }
        if (data["amount"] > 0) {
          notZero.push(data);
        } else {
          returnData.push(data);
        }
      }
      var search = this.searchCurr.toLowerCase();
      return notZero
        .concat(returnData)
        .filter((val) =>
          this.searchCurr
            ? val.symbol.toLowerCase().includes(search) ||
              val.currency_name.toLowerCase().includes(search)
            : true
        );
    },
    subscribPairs(pairList) {
      try {
        if (pairList.length > 0) {
          this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
            "S_PF_PF"
          ].subscribe(pairList);
        }
      } catch (e) {
        setInterval(() => {
          this.subscribPairs(pairList);
        }, 1000);
      }
    },
    getCurrency(value) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
        let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
        this.subscribPairs(btcPair.concat(usdPair));
        this._runGetMarginInfo({
          globalParams: { account_id: this.tradingAccount[0].account_id },
          localParams: { parameter: this, page: "deposit" },
        });
      }
    },
    transactionLimitCurrency(clear) {
      this.notification_msg = "";
      this.notification_type = "";
      this.$store.commit("/SET_GENERATE_WALLET_ADDRESS", "");
      
      let selected_currency = this.selected_currency.toUpperCase()
      for(let key in this.$env_var.restricted_currencies){
        if(this.$env_var.restricted_currencies[key].currency_name == this.selected_currency){
          selected_currency = this.$env_var.restricted_currencies[key].orginal_name
        }
      }

      if ( this.notCryptoCurrency.includes(selected_currency) ) {
        this.crypto = false;
      } else {
        this.crypto = true;
        this.getAddress();
      }
    },
    getAddress() {
      var account_id = "";
      var sendCurr = this.selected_currency ;
      if (this.tradingAccount.length > 0) {
        this.tradingAccount[0].subAccounts.forEach((value) => {
          if(this.$env_var.restricted_currencies.hasOwnProperty(value.currency) && this.$env_var.restricted_currencies[value.currency].currency_name == this.selected_currency){
            account_id = value.act_account_id;
          }else if(this.selected_currency == value.currency) {
            account_id = value.act_account_id;
          }
        });
      }

      for(let key in this.$env_var.restricted_currencies){
        if(this.$env_var.restricted_currencies[key].currency_name == this.selected_currency){
          sendCurr = this.$env_var.restricted_currencies[key].orginal_name
        }
      }
      this._runGenerateWalletAddress({
        globalParams: {
          currency: sendCurr,
          act_account_id: account_id,
        },
        localParams: { parameter: this },
      });
    },
    onCopy(e) {
      if ((this.copyText = "1")) {
        this.copy_msg1 = true;
      } else {
        this.copy_msg2 = true;
      }
      var _that = this;
      setTimeout(function () {
        _that.copy_msg1 = false;
        _that.copy_msg2 = false;
      }, 2000);
    },
    onError(e) {
      var _that = this;
      try {
        _that.notification_msg = "Address not Copied";
        _that.notification_type = "error";

        setTimeout(function () {
          _that.notification_msg = "";
          _that.notification_type = "";
        }, 5000);
      } catch (e) {}
    },
    downloadTransactions() {
      if(this.downloadData.records && this.downloadData.records.length > 0){
        let headerCols = [],
        data = [],
        filename = "";
        filename = "deposits";
        headerCols = Object.keys(this.downloadData.records[0]);
        data = this.downloadData.records;
        this.csvExport(data, headerCols, filename);
      }else{
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'No data available',
          duration: 1000
        });
      }
    },
    csvExport(data, headers, filename) {
      let csvData = headers.join(", ").replace(/_/g, " ").toUpperCase();
      csvData += "\n";
      data.map((row) => {
        headers.map((i, index) => {
          if (index < headers.length - 1) {
            csvData += `${row[i]}, `;
          } else {
            csvData += `${row[i]}\n`;
          }
        });
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csvData);
      hiddenElement.target = "_blank";
      hiddenElement.download = filename;
      hiddenElement.click();
    },
  },
  created() {
    if (this.$route.query.deposit) {
      this.selected_currency = this.$route.query.deposit;
      if(this.$env_var.restricted_currencies.hasOwnProperty(this.$route.query.deposit) ){
        this.selected_currency = this.$env_var.restricted_currencies[this.$route.query.deposit].currency_name;
      }
    }
    this.getCurrency(this.tradingAccount);
    this.depositListing(this.tradingAccount);
    this._runGetWithDepoCurList({
      globalParams: {},
      localParams: { parameter: this, 'link':true },
    });
  },
  updated() {
    if (this.showCurr) {
      document.getElementById("searchCurr").focus();
    }
  },
  mounted() {
    const _that = this;
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".showCurr").length) {
        _that.showCurr = false;
      }
    });
  },
};
</script>
<style>
.firstName.currErr {
  margin-right: 12px;
  width: 35px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/deposit.vue